module.exports = __webpack_public_path__ + "img/truid_logo.47fd19a2.svg";